<template>
	<div class="sky-uploadimg-select">
		<div v-bind:class="[getClass, { errorBorder: isTrue }]" class="upload_body">
			<ul
				class="el-upload-list el-upload-list--picture-card upload-ul"
				:class="showFileInfo && 'upload-filename'"
			>
				<li
					v-for="(file, index) in editorFileList"
					:key="index"
					tabindex="0"
					class="el-upload-list__item is-success"
					:class="{ isSelect: file.ossName === selectFile.ossName }"
					@click="select(file)"
				>
					<img
						:src="file.url"
						alt
						class="el-upload-list__item-thumbnail"
						style="object-fit: contain"
					/>
					<span class="el-upload-list__item-actions">
						<span @click.stop="preview(file)" class="el-upload-list__item-preview icon_body">
							<i class="el-icon-zoom-in"></i>
						</span>
						<span @click.stop="download(file)" class="el-upload-list__item-preview icon_body">
							<i class="el-icon-download"></i>
						</span>
						<span
							@click.stop="editorRemove(file, index)"
							class="el-upload-list__item-delete icon_body"
							v-if="!readOnly"
						>
							<i class="el-icon-delete"></i>
						</span>
					</span>
					<i class="el-icon-success select_icon"></i>
				</li>
			</ul>
			<el-upload
				:action="action"
				:accept="accept || '*'"
				list-type="picture-card"
				:readOnly="readOnly"
				:http-request="action && action != '' ? undefined : uploadSectionFile"
				ref="upload"
				:file-list="fileList"
				:show-file-list="false"
				:on-success="success"
				:on-error="error"
				class="upload"
				:on-preview="preview"
				:on-remove="remove"
			>
				<i class="el-icon-plus"></i>
			</el-upload>
		</div>

		<div class="img_config_body" v-if="selectFile.ossName">
			<el-radio-group v-model="selectFile.jumpType" size="mini" @input="imgConfigChange">
				<el-radio :label="1" border>站内页面</el-radio>
				<el-radio :label="2" border>站外链接</el-radio>
			</el-radio-group>

			<!-- <el-select
				v-model="selectFile.oneContent"
				placeholder="请选择站内页面"
				v-if="selectFile.jumpType == 1"
				@change="imgConfigChange"
			>
				<el-option
					v-for="item in options"
					:key="item.value"
					:label="item.label"
					:value="item.value"
				>
				</el-option>
			</el-select> -->

			<el-cascader
				v-if="selectFile.jumpType == 1"
				v-model="selectFile.oneContent"
				placeholder="请选择站内页面"
				:options="options"
				filterable
				:show-all-levels="false"
				:props="props"
				@change="imgConfigChange"
			></el-cascader>

			<el-input
				v-model="selectFile.twoContent"
				placeholder="请输入站外链接"
				v-if="selectFile.jumpType == 2"
				@input="imgConfigChange"
			></el-input>
		</div>

		<!-- 查看详情图片  -->
		<sky-img-rotate
			:file="currentFile"
			:file-name="filename"
			:visible.sync="dialogVisible"
			title="查看图片"
			:img-url="dialogImgUrl"
			@on-cancel="dialogVisible = false"
			:append="true"
		></sky-img-rotate>
	</div>
</template>

<script>
import skyUploadimgSelectMixins from './mixins/skyUploadimgSelectMixins.js';

export default {
	name: 'sky-uploadimg-select',
	mixins: [skyUploadimgSelectMixins],
	props: {
		options: {
			required: false,
		},
		props: {
			required: false,
		},
	},
	data() {
		return {
			selectFile: {
				jumpType: 1,
				oneContent: '',
				twoContent: '',
			},
		};
	},
	methods: {
		// 选择图片
		select(file) {
			this.selectFile = file;
		},
		// 图片配置项发生变化
		imgConfigChange() {
			let { selectFile } = this;
			this.editorFileList.forEach(item => {
				if (item.ossName == selectFile.ossName) {
					item = {
						...item,
						...selectFile,
					};
				}
			});
		},
	},
};
</script>

<style lang="scss" scoped>
.upload {
	height: 80px;
}

.sky-uploadimg-select {
	.upload_body {
		display: flex;

		.el-upload-list {
			.el-upload-list__item {
				.el-upload-list__item-actions {
					display: flex;
					justify-content: center;
					align-items: center;
					cursor: pointer;

					.icon_body {
						margin: 0 2px;
					}
				}

				.select_icon {
					display: none;
				}
			}

			.isSelect {
				position: relative;
				border: 2px solid #409eff;

				.select_icon {
					position: absolute;
					bottom: 1px;
					right: 1px;
					display: inline-block;
					font-size: 18px;
					color: #67c23a;
				}
			}
		}
	}

	.img_config_body {
		display: flex;
		flex-direction: column;
		width: 300px;

		.el-cascader,
		.el-input {
			margin-top: 10px;
		}
	}
}
</style>

<style>
.errorBorder b {
	display: block;
	color: red;
}

.errorBorder .upload {
	padding: 10px;
	border: 1px solid red;
	border-radius: 4px;
}

.el-upload--picture-card {
	background: #f2f2f2;
	border: none;
	width: 80px;
	height: 80px;
	line-height: 80px;
}

.el-upload-list--picture-card .el-upload-list__item {
	width: 80px;
	height: 80px;
}

.hide-add-btn .el-upload--picture-card {
	display: none;
}
</style>
